<template>
  <div>
    <div class="flex justify-between items-center mb-4">
      <h5 class="flex items-center"><i class="dot"></i>위험성평가</h5>
      <div v-if="!readonly && !isPrint">
        <vs-button color="secondary" type="border" @click="handleAddRow"> 항목추가 </vs-button>
        <vs-button class="ml-4" color="secondary" @click="handleRemoveRow"> 선택삭제 </vs-button>
      </div>
    </div>

    <table>
      <colgroup>
        <col v-if="!readonly" width="36" />
        <col />
        <col />
        <col width="320" />
        <col />
        <col width="46" />
        <col width="46" />
        <col width="46" />
        <col width="320" />
        <col />
        <col width="74" />
        <col width="74" />
      </colgroup>
      <thead>
        <tr>
          <th v-if="!readonly" rowspan="3">
            <vs-checkbox :value="checkData.length === list.length && 0 < list.length" class="justify-center mx-0" @click.native="onClickAllCheck" />
          </th>
          <th rowspan="3"><div class="w-full text-center">①공종분류</div></th>
          <th rowspan="3"><div class="w-full text-center">②단위작업</div></th>
          <th rowspan="3"><div class="w-full text-center">③위험요인</div></th>
          <th rowspan="3"><div class="w-full text-center">재해형태</div></th>
          <th colspan="3" class="text-center">④위험성 결정</th>
          <th rowspan="3"><div class="w-full text-center">⑤위험방지대책</div></th>
          <th rowspan="3">
            <div class="w-full text-center">⑥개선조치 담당자<br />(조치예정일)</div>
          </th>
          <th rowspan="2" colspan="2">
            <div class="w-full text-center">➉이행확인<br />(조치한 경우 √)</div>
          </th>
        </tr>
        <tr>
          <th colspan="3" class="text-center">위험도 등급</th>
        </tr>
        <tr>
          <th class="text-center">상</th>
          <th class="text-center">중</th>
          <th class="text-center">하</th>
          <th class="text-center">근로자대표</th>
          <th class="text-center">공사담당자</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.id">
          <td v-if="!readonly" style="background: #f9f9f9"><vs-checkbox v-model="checkData" :vs-value="item.id" /></td>
          <td><ml-input :readonly="readonly" v-model="item.input1" class="w-full" placeholder="철근작업" /></td>
          <td><ml-input :readonly="readonly" v-model="item.input2" class="w-full" placeholder="철근조립" /></td>
          <td><ml-textarea :readonly="readonly" rows="3" v-model="item.input3" placeholder="8층 기둥철근조립 중 틀비계 안전난간대 미 설치로 인한 추락위험" class="w-full mb-0" /></td>
          <td>
            <disaster-class-selector class="disaster" :readonly="readonly" v-model="item.input4" />
          </td>
          <td>
            <PrintRadio v-if="readonly" :value="item.input5 === '상'" class="justify-center" />
            <vs-radio v-else :vs-name="item.id" vs-value="상" v-model="item.input5" />
          </td>
          <td>
            <PrintRadio v-if="readonly" :value="item.input5 === '중'" class="justify-center" />
            <vs-radio v-else :vs-name="item.id" vs-value="중" v-model="item.input5" />
          </td>
          <td>
            <PrintRadio v-if="readonly" :value="item.input5 === '하'" class="justify-center" />
            <vs-radio v-else :vs-name="item.id" vs-value="하" v-model="item.input5" />
          </td>
          <td>
            <ml-textarea :readonly="readonly" rows="3" v-model="item.input6" placeholder="- 이동식비계 3 SET 반입 시 안전난간대 수량 확인(부족분 작업전 반입)  - 이동식비계 안전난간대 4개소 설치(상부 및 하부 난간대)" class="w-full mb-0" />
          </td>
          <td>
            <ml-input :readonly="readonly" v-model="item.input7" class="w-full mb-2" placeholder="홍길동 반장" />
            <date-selector :readonly="readonly" v-model="item.input8" class="w-full" placeholder="날짜선택" />
          </td>
          <td>
            <PrintCheckbox v-if="readonly" label="" :value="item.input9" style="width: fit-content" class="mx-auto" />
            <vs-checkbox v-else v-model="item.input9" />
          </td>
          <td>
            <PrintCheckbox v-if="readonly" label="" :value="item.input10" style="width: fit-content" class="mx-auto" />
            <vs-checkbox v-else v-model="item.input10" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import PrintRadio from "@/components/print/PrintRadio.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
export default {
  components: {
    DisasterClassSelector,
    DateSelector,
    PrintRadio,
    PrintCheckbox,
  },
  props: {
    readonly: { type: Boolean, default: false },
    isPrint: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      checkData: [],
      list: this.value,
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
        this.numberId = 0 < value.length ? value[value.length - 1].id : 0;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    // All 체크박스 클릭
    onClickAllCheck() {
      if (this.checkData.length === this.list.length) this.checkData = [];
      else this.checkData = this.list.map((item) => item.id);
    },
    // 항목추가
    handleAddRow() {
      const addData = { id: ++this.numberId };
      this.list.push(addData);
    },
    // 선택삭제
    handleRemoveRow() {
      this.list = this.list.filter((item) => !this.checkData.includes(item.id));
      this.checkData = [];
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 5px;

    &::v-deep .con-vs-checkbox {
      justify-content: center !important;
      margin: 0;
      span {
        margin: 0;
      }
    }
    &::v-deep .con-vs-radio {
      width: 100%;
      justify-content: center !important;
    }
  }
  th {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;

    background: #f9f9f9;
    padding: 7px;
  }
}

.disaster::v-deep {
  .con-select {
    width: 100%;
  }
}
</style>
